module.exports = __webpack_public_path__ + "img/Brochure-Bill-Parks-small.117c46d0.jpg";